<template>
  <div>

    <ProductCardWelcomeRow
      class="text-section"
      :is-subscribed="isSubscribed"
      :name="productName"
    />

    <div class="text-section mt-0">
      Your agency is currently
      <span v-if="!isSubscribed" class="red--text font-weight-bold">
        Unsubscribed
      </span>
      <span v-else-if="subscriptionStatus === 1" class="blue--text font-weight-bold">
        Pending Subscription
      </span>
      <span v-else class="green--text font-weight-bold">
        Subscribed
      </span>
      to the
      <strong>{{ productName }}</strong> product.
    </div>

    <div class="text-section">
      <div class="title">Monthly Fee</div>
      <div class="text">
        <span class="font-weight-bold">HawkSoft Text Messaging requires a fee of $20 per month per agency for unlimited texting. This will be added to your HawkSoft invoice.</span> This fee covers the per-message fees, brand registration fees, and monthly campaign fees imposed by telecom carriers for sending business texts on 10DLC routes.
        <a target="_blank" href="https://blog.hawksoft.com/10dlc-policies-introduction">Learn More</a>
      </div>
    </div>

    <div class="text-section">
      <div class="title">
        Opt-In and Additional Information Required
      </div>
      <div class="text">
        FCC’s Telephone Consumer Protection Act requires your customers to opt in to receive text messages from your agency. HawkSoft automates the opt-in process.
        <a target="_blank" href="https://blog.hawksoft.com/texting-best-practices-tcpa-compliance#h3">Learn More</a>
      </div>
      <div class="text">
        To be compliant with telecom carrier requirements, additional information is required from an agency before HawkSoft Text Messaging can be activated.
        <a target="_blank" href="https://blog.hawksoft.com/10dlc-policies-introduction">Learn More</a>
      </div>
    </div>

    <div class="text-section">
      <div class="title">
        Text Messaging for Marketing Purposes is Prohibited
      </div>
      <div class="text">
        HawkSoft Text Messaging is only for informational texts. HawkSoft does not allow the use of text messaging for marketing purposes.
        <span class="font-italic">You may also be in violation of federal or state regulations if you use texting for marketing purposes.</span>
      </div>
    </div>

    <div class="text-section">
      <div class="title">
        One Text Messaging Phone Number
      </div>
      <div class="text">
        Your agency is assigned one (1) central text message phone number. HawkSoft provides you this number, or you can use a number that you already have. Even if multiple staff members are texting a client, that client will see text messages arriving from a single phone number.
      </div>
    </div>

    <div class="text-section">
      <div class="title">
        Terms and Conditions
      </div>
      <div class="text">
        Your continued use of HawkSoft Text Messaging constitutes acceptance of the HawkSoft Text Messaging Terms and Conditions:
        <a href="https://www.hawksoft.com/terms/text-messaging/">Terms and Conditions</a>
      </div>
    </div>

    <div
      v-if="!isSubscribed"
      class="subtitle-1 text-section"
    >
      Click Next to begin setting up your agencies phone number!
    </div>
  </div>
</template>

<style lang="sass" scoped>
@import '~vuetify/src/styles/main.sass'

.title
  // @extend .title // automatically extends/combines same name class
  // margin: 3rem 3rem 3rem 3rem
  color: #004C97

.text-section
  @extend .my-3

.text
  @extend .my-1
  @extend .ml-2

</style>

<script>
import ProductCardWelcomeRow from '@/components/products/shared/ProductCardWelcomeRow';

export default {
  name: 'TextingWelcome',
  components: {
    ProductCardWelcomeRow
  },
  props: {
    isSubscribed: {
      type: Boolean,
      required: true
    },
    productName: {
      type: String,
      required: true
    },
    subscriptionStatus: {
      // 0 = subscribed
      // 1 = pending
      type: Number,
      default: 1
    }
  }
};
</script>
